import { createRouter } from '@tanstack/react-router';

import { RootRoute } from 'src/routes/__root';
import {
  ConfigurationDefaultRoute,
  ConfigurationRoute,
} from 'src/routes/configuration';
import { ForbiddenDefaultRoute, ForbiddenRoute } from 'src/routes/forbidden';
import {
  ForecastDefaultRoute,
  ForecastRoute,
  ForecastSkuRoute,
} from 'src/routes/forecast';
import { NoveltiesDefaultRoute, NoveltiesRoute } from 'src/routes/novelties';
import {
  PreferencesDefaultRoute,
  PreferencesRoute,
} from 'src/routes/preferences';
import { useBoundStore } from 'src/store/store';

const routeTree = RootRoute.addChildren({
  ForecastRoute: ForecastRoute.addChildren([
    ForecastDefaultRoute,
    ForecastSkuRoute,
  ]),
  ConfigurationRoute: ConfigurationRoute.addChildren([
    ConfigurationDefaultRoute,
  ]),
  NoveltiesRoute: NoveltiesRoute.addChildren([NoveltiesDefaultRoute]),
  PreferencesRoute: PreferencesRoute.addChildren([PreferencesDefaultRoute]),
  ForbiddenRoute: ForbiddenRoute.addChildren([ForbiddenDefaultRoute]),
});

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

router.subscribe('onBeforeNavigate', () => {
  useBoundStore.getState().clearLoading();
});
